window.$ = window.jQuery = require('jquery');

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

import AOS from 'aos';
AOS.init({
    offset: 0,
    duration: 600,
    easing: 'ease-in-sine',
    anchorPlacement: 'top-bottom'
});

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
const fPageNav = require('./components/page-nav')
const fSidebar = require('./utils/sidebar')
const fCarousels = require('./components/carousels')
const fGSAPController = require('./components/gsap-controller')
const fGoogleMapsController = require('./components/gMapsAPI')

// Vue Support Function
import {
    createApp,
    defineAsyncComponent
} from 'vue'

const InitVueComponents = () => {
    // Async components
    // const SimpleComponent = defineAsyncComponent(() => import("./vue/simple-component"));
    // Static Components
    // const StaticComponent = require('./vue/multi-file-component/child-component').default;

    // Init Vue Instance
    const $VueApp = createApp({});

    // component() can be chained :)

    // $VueApp
    //     .component("child-component", StaticComponent);
    // $VueApp.mount('#vue-space');
}

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    // Static Functions
    fSmoothScroll()
    fSidebar()
    InitVueComponents()
    // fPageNav()

    // Async Functions
    fCarousels.init()
    fGSAPController.init()
    fGoogleMapsController.init()

    $('.bodyWithFade').fadeOut(0);
    $('.bodyWithFade').removeClass('invisible');
    $('.bodyWithFade').fadeIn(1000);
})